import { createReducer, on } from '@ngrx/store';
import {
  BUSINESS_SETTING_FIND_SUCCESS,
  BUSINESS_SETTING_FAILURE,
  BUSINESS_SETTING_UPDATE_FORM,
  BUSINESS_SETTING_RESET_ERROR,
  BUSINESS_SETTING_RESET,
  BUSINESS_SETTING_RESET_FORM,
  BUSINESS_SETTING_FIND_ALL_SUCCESS,
  BUSINESS_SETTING_EDIT_MODE,
  BUSINESS_SETTING_CLEAR_STATE,
  BUSINESS_SETTING_UPDATE_LOADING,
  BUSINESS_SETTING_UPDATE_ID,
  BUSINESS_SETTING_UPDATE_FORM_VALID
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  ConfiguracionGeneral,
  ConfiguracionGeneralForm,
} from '@core/models';

export interface BusinessSettingState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  businessSettingId: string | null;
  businessSetting: ConfiguracionGeneral | null;
  businessSettingList: ConfiguracionGeneral[] | null;
  businessSettingForm: ConfiguracionGeneralForm | null;
  error: ResponseBadRequest | null;
  validForm: boolean;
}

export const initialState: BusinessSettingState = {
  loading: false,
  isEditing: false,
  editMode: false,
  businessSettingId: null,
  businessSetting: null,
  businessSettingList: null,
  businessSettingForm: null,
  error: null,
  validForm: false
};

export const businessSettingReducer = createReducer(
  initialState,
  on(BUSINESS_SETTING_UPDATE_FORM_VALID, (state, { validForm }) => ({ ...state, validForm })),
  on(BUSINESS_SETTING_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(BUSINESS_SETTING_FIND_SUCCESS, (state, { businessSetting }) => ({ ...state, businessSetting })),
  on(BUSINESS_SETTING_FIND_ALL_SUCCESS, (state, { businessSettingList }) => ({ ...state, businessSettingList })),
  on(BUSINESS_SETTING_FAILURE, (state, { error }) => ({ ...state, error })),
  on(BUSINESS_SETTING_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(BUSINESS_SETTING_UPDATE_FORM, (state, { businessSettingForm }) => ({ ...state, businessSettingForm })),
  on(BUSINESS_SETTING_UPDATE_ID, (state, { businessSettingId }) => ({ ...state, businessSettingId })),
  on(BUSINESS_SETTING_RESET, (state) => ({ ...state, businessSetting: null, businessSettingId: null, businessSettingForm: null })),
  on(BUSINESS_SETTING_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(BUSINESS_SETTING_RESET_FORM, (state) => ({ ...state, businessSettingForm: null, loading: false })),
  on(BUSINESS_SETTING_CLEAR_STATE, () => initialState),
);